<template>
  <div class="logo-jumbotron">
    <el-button @click="back" class="back-button">{{
      $t("B2B.back")
      }}</el-button>
    <div class="decorate left top"></div>
    <div class="decorate left bottom"></div>
    <div class="decorate right top"></div>
    <div class="decorate right bottom"></div>
    <div class="box login">
      <img src="../assets/img/logo.png" class="logo" />
      <img src="../assets/img/descript.png" class="descript" />
    </div>
    <el-form :model="form" status-icon :rules="rules" ref="form" class="form">
      <el-form-item prop="radio">
        <el-radio v-model="form.radio" label="1" v-if="!isB2B">{{
          $t("login.userLogin")
          }}</el-radio>
        <el-radio v-model="form.radio" :disabled="isDetail ? true : false" label="2" v-if="isB2B">{{
          $t("login.supplierLogin") }}</el-radio>
      </el-form-item>
      <el-form-item prop="email" v-if="form.radio == '1'">
        <label for="email" class="required">*</label>
        <el-input v-model="form.email" :placeholder="$t('login.inputEmail')"></el-input>
      </el-form-item>
      <el-form-item prop="phone" v-if="form.radio == '2'">
        <label for="phone" class="required">*</label>
        <el-input v-model="form.phone" :placeholder="$t('login.inputPhone')"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <label for="password" class="required">*</label>
        <el-input v-model="form.password" :placeholder="$t('login.inputPassword')" show-password></el-input>
      </el-form-item>
      <router-link :to="{ path: '/forget', query: { B2B: this.isB2B } }" class="forget">{{ $t("login.forgetPassword")
        }}</router-link>
      <el-form-item>
        <el-button type="success" round @click="login">{{
          $t("login.login")
          }}</el-button>
      </el-form-item>
    </el-form>
    <div class="no-account">
      <span>{{ $t("login.registerText") }}</span>
      <router-link :to="{ path: '/register', query: { B2B: this.isB2B } }">{{
        $t("login.register")
        }}</router-link>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { SET_AUTH } from "../store/mutation-types";

export default {
  name: "Login",
  data() {
    return {
      form: {
        radio: "1",
        email: "",
        phone: "",
        password: ""
      },
      isDetail: false,
      shopId: "", // 商品
      productNumber: "", // 商品id
      isB2B: false,
      rules: {
        email: [
          {
            required: true,
            message: this.$t("login.inputEmail"),
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: this.$t("login.inputPhone"),
            trigger: "blur"
          },
          {
            pattern: /^(1[0-9]{10})$/,
            message: this.$t("login.inputCorrect"),
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: this.$t("login.inputPassword"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    const { IsDetail, ProductNumber, ShopId, B2B } = this.$route.query;
    this.isDetail = IsDetail;
    if (this.isDetail) {
      this.productNumber = ProductNumber;
      this.shopId = ShopId;
    }
    this.isB2B = B2B;
    if (this.isB2B) {
      this.form.radio = "2";
    }
    localStorage.removeItem("agreedState");
  },
  methods: {
    back() {
      if (this.isB2B) {
        this.$router.replace("/");
      } else {
        this.$router.replace("/home");
      }
    },
    login() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.radio == "1") {
            this.clogin();
          } else {
            this.supplierLogin();
          }
        } else {
          return false;
        }
      });
    },
    clogin() {
      this.$api.clogin
        .userLogin({
          UserName: this.form.email,
          Password: this.form.password
        })
        .then(response => {
          this.$message({
            message: this.$t("login.loginSuccess"),
            type: "success"
          });
          response.data.Type = "C";
          this.SET_AUTH(response.data);
          if (this.isDetail) {
            this.$router.replace({
              path: "/details",
              query: { ProductNumber: this.productNumber, ShopId: this.shopId }
            });
          } else {
            this.$router.push("/cUser");
          }
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },
    supplierLogin() {
      this.$api.login
        .userLogin({
          UserName: this.form.phone,
          Password: this.form.password
        })
        .then(response => {
          this.$message({
            message: this.$t("login.loginSuccess"),
            type: "success"
          });
          response.data.Type = "SU";
          this.SET_AUTH(response.data);
          this.gotoActivate(response.data.SystemCurrentUseMode);
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },
    gotoActivate(mode) {
      this.$router.replace({ path: "/activate", query: { Mode: mode } });
    },
    gotoB2B() {
      this.$router.replace("/public");
    },
    gotoSupplier() {
      this.$router.replace("/supplier");
    },
    ...mapMutations([SET_AUTH])
    // console.log( ...mapMutations([SET_AUTH]));
  }
};
</script>

<style lang="scss" scoped>
.form {
  z-index: 1;
  width: 300px;
  margin: 106px auto 0;

  label.required {
    position: absolute;
    font-size: 20px;
    color: #ff5852;
    left: -20px;
    top: 6px;
  }

  // 修改 element ui 默认样式
  ::v-deep {
    .el-form-item {
      margin-bottom: 18px;
    }

    .el-input__inner {
      height: 50px;
      border-radius: 25px;
    }

    .el-input__inner:focus {
      border-color: #22b122;
    }

    .el-form-item__error {
      top: 16px;
      left: 100%;
      width: 300px;
      font-size: 16px;
      padding-top: 0;
      padding-left: 44px;
    }

    .el-input__suffix {
      left: 100%;
      padding-left: 14px;
    }

    .el-input__icon {
      width: 20px;
    }

    .el-form-item .el-input__validateIcon {
      background-repeat: no-repeat;
      background-position: center;
      background-image: url("../assets/img/icon_logn_in_right.png");
    }

    .el-form-item.is-error .el-input__validateIcon {
      background-image: url("../assets/img/icon_logn_in_worng.png");
    }

    .el-icon-circle-close:before,
    .el-icon-circle-check:before {
      content: "";
    }

    .el-input__suffix-inner {
      display: none;
    }

    .el-button {
      width: 100%;
      margin-top: 30px;
      background-color: #22b196;
      border-color: #22b196;
      font-size: 20px;
      font-weight: normal;
      height: 50px;
      border-radius: 25px;
      box-shadow: 0 6px 6px 0 rgba(103, 182, 206, 0.35);
    }
  }
}

.no-account {
  z-index: 1;
  position: relative;
  text-align: center;
  padding-top: 18px;
  color: #989898;
  font-size: 16px;
  padding-bottom: 80px;

  a {
    font-size: 20px;
    color: #22b196;
    margin-left: 5px;
  }
}

.back-button {
  margin-left: 30px;
  margin-top: 30px;
  position: absolute;
  z-index: 11;
}

.forget {
  color: #22b196;
  display: block;
  text-align: right;
}
</style>
